import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerEvent = new Swiper(".banner__event", {
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 32,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".event-button-next",
            prevEl: ".event-button-prev",
        },
    });

    let galleryAbout = new Swiper(".gallery__about", {
        slidesPerView: 2.3,
        spaceBetween: 24,
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
        },
        autoplay: {
            delay: 3500,
        },
    });

    let galleryAboutComplex = new Swiper(".gallery__about-complex", { 
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            delay: 3400,
        },
        navigation: {
            nextEl: ".about-complex-button-next",
            prevEl: ".about-complex-button-prev",
        },
        breakpoints: {
            1400: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 3,
            },
            800: {
                slidesPerView: 1,
            },
        },
    });

    let accommodationSlider = new Swiper(".accommodation__slider", {
        centeredSlides: true,
        loop: true,
        speed: 1000,
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            delay: 3400,
        },
        navigation: {
            nextEl: ".accommodation-button-next",
            prevEl: ".accommodation-button-prev",
        },
        breakpoints: {
            1400: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 3,
            },
            800: {
                slidesPerView: 1,
            },
        },
    });

    const accommodations = document.querySelectorAll(".accommodations__slider");

    accommodations.forEach((item) => {
        let accommodationsSlider = new Swiper(item, {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: ".accommodations-button-next",
                prevEl: ".accommodations-button-prev",
            },
        });
    });

    let gallerySlider = new Swiper(".gallery-discover__slider", {
        slidesPerView: 3,
        spaceBetween: 30,
        autoplay: {
            delay: 3400,
        }, 
        breakpoints: {
            1400: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 3,
            },
            800: {
                slidesPerView: 1,
            },
        },
        navigation: {
            nextEl: ".gallery-discover-button-next",
            prevEl: ".gallery-discover-button-prev",
        }, 
    });

    let attractivesSlider = new Swiper(".attractives-slider", {
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
            nextEl: ".attractives-button-next",
            prevEl: ".attractives-button-prev",
        },
        breakpoints: {
            900: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 1,
            },
        },
    });

    let gallerySingleEvents = new Swiper(".gallery-slider", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 30,
        navigation: {
            nextEl: ".gallery-button-next",
            prevEl: ".gallery-button-prev",
        },
        breakpoints: {
            900: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 1,
            },
        },
    });

    document.querySelectorAll('.gallery-hotel-slider').forEach((sliderEl, index) => {
        new Swiper(sliderEl, {
            watchOverflow: true,
            slidesPerView: 3,
            spaceBetween: 30, 
            navigation: {
            nextEl: sliderEl.querySelector('.gallery-hotel-button-next'),
            prevEl: sliderEl.querySelector('.gallery-hotel-button-prev'),
            },
             autoplay: {
            delay: 3000,                
            disableOnInteraction: false,  
            },
            breakpoints: {
            900: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 1,
            },
            },
        });
    });
 
    document.querySelectorAll('.gallery-complex-slider').forEach((sliderEl, index) => {
        new Swiper(sliderEl, {
            watchOverflow: true,
            slidesPerView: 3,
            spaceBetween: 30, 
            navigation: {
            nextEl: sliderEl.querySelector('.gallery-complex-button-next'),
            prevEl: sliderEl.querySelector('.gallery-complex-button-prev'),
            },
             autoplay: {
            delay: 3000,                
            disableOnInteraction: false,  
            },
            breakpoints: {
            900: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 1,
            },
            },
        });
    });
};
